module.exports = __webpack_public_path__ + "img/icon_Global_Web_Development.1be417b0.svg";